import mixins from '~/mixins/global';
import {sortByDate} from "@/helpers/common";

export async function getListTodo({commit}, payload) {
  const {errResponse, data: responseData} = await this.$frontendRepositories.proposals.getTodoList(payload);

  const todos = responseData.data.proposals;
  const years = responseData.data.years;

  sortByDate(todos.data, 'asc', 'proposal_at');

  if (!errResponse && responseData.success) {
    commit('setYears', years);
    return commit('setList', todos);
  }

  return Promise.resolve([]);
}

export async function create({commit, dispatch}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.todos.create(payload);
  await dispatch('getListTodo');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function update({dispatch, commit}, payload) {
  commit('setBtnLoading', true, {root: true});
  const response = await this.$frontendRepositories.todos.update(payload.id, payload);
  await dispatch('getListTodo');
  commit('setBtnLoading', false, {root: true});
  return response;
}

export async function handleTodoActionUpdate({dispatch, commit}, payload) {
  const response = await this.$frontendRepositories.todos.todoActionUpdate(payload);
  return response;
}
